<template>
  <el-container class="app-container">
    <loading :fullscreenLoading="fullscreenLoading"
             :text="'退出中,请稍等片刻...'" />

    <!-- <el-header class="app-header">
      <horizontal-nav />
      <section class="user-detail">
        <i class="el-icon-search"></i>
        <i class="el-icon-bell"></i>
        <el-tooltip effect="dark"
                    :content="toolTip"
                    placement="bottom-end">
          <span class="user-logo"></span>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="sessData.userName"
                    :disabled="!showUserTip">
          <span class="user-name"
                :class="{'name-ellipsis': showUserTip}">{{sessData.userName}}</span>
        </el-tooltip>
        <i class="el-icon-switch-button"
           @click="handleSignOutClick"></i>
      </section>
    </el-header> -->
    <el-container>
      <el-main class="app-main">
        <yh-tabs />
        <keep-alive :include="keepAlivePages">
          <router-view class="box"></router-view>
        </keep-alive>
      </el-main>
    </el-container>
    <!-- <yh-dialog title="用户首次登录信息核对与修改"
               :visible.sync="credentialsDialog">
      <el-form :model="tableData">
        <el-form-item label="*姓名 :">
          <el-input maxlength="20"
                    v-model="tableData.userName"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="*操作员号 :">
          <el-input maxlength="20"
                    v-model="tableData.workNo"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="*手机号码 :">
          <el-input maxlength="20"
                    v-model="tableData.phone"></el-input>
        </el-form-item>
        <el-form-item label="*所在机构名称 :">
          <el-input maxlength="20"
                    v-model="tableData.orgnName"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="*机构号 :">
          <el-input maxlength="20"
                    v-model="tableData.orgnCode"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="*性别 :">
          <el-select v-model="tableData.gender"
                     placeholder="请选择性别">
            <el-option v-for="item in genderSelect"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*角色名称 :">
          <el-input maxlength="20"
                    v-model="tableData.roleName"
                    disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary">确定</el-button>
      </span>
    </yh-dialog> -->
  </el-container>
</template>

<script>
import { addNav, getFunctionList } from '@/mixins';

export default {
  name: 'Home',
  mixins: [addNav, getFunctionList],
  data() {
    return {
      functionList: [],
      activeMenu: '',
      genderSelect: [
        {
          label: '男',
          value: '1',
        },
        {
          label: '女',
          value: '0',
        },
      ],
      credentialsDialog: false,
      tableData: {
        userName: '',
        // workNo: '',
        phone: '',
        orgnName: '',
        orgnCode: '',
        gender: '',
        roleName: '',
      },
      fullscreenLoading: false,
      sessData: JSON.parse(sessionStorage.getItem('sessionData')),
      pageTab: this.$store.state.pageTab,
    };
  },
  computed: {
    menuList() {
      return [
        {
          label: '今日计划',
          path: '/call-plan',
          icon: 'el-icon-s-claim',
          visible: this.canViewTodayPlan,
        },
        {
          label: '今日业绩',
          path: '/today-performance',
          icon: 'el-icon-s-marketing',
          visible: this.canViewPerformance,
        },
        {
          label: '今日到访',
          path: '/fieldServRecordQuery',
          icon: 'el-icon-s-custom',
          visible: this.canViewService,
        },
        {
          label: '最新产品',
          path: '/latest-product',
          icon: 'el-icon-s-goods',
          visible: this.canViewMoreLatest,
        },
      ];
    },
    canViewLatestProductDetail() {
      return this.functionList.includes('336040758297202688');
    },
    canViewMoreLatest() {
      return this.functionList.includes('336040364020043776');
    },
    canViewPerformance() {
      return this.functionList.includes('336040063301029888');
    },
    canViewTodayPlan() {
      return this.functionList.includes('322222700680155136');
    },
    canViewService() {
      return this.functionList.includes('329526117392097280');
    },
    keepAlivePages() {
      return this.$store.getters.keepAlivePages;
    },
    // toolTip() {
    //   return `工号: ${this.sessData.workNo} / 角色: ${this.sessData.roleName} / 机构名称: ${this.sessData.orgnName} / 机构编号: ${this.sessData.orgnCode}`;
    // },
    showUserTip() {
      return this.sessData.userName?.length > 5;
    },
  },
  watch: {
    $route() {
      const { path } = this.$route;
      if (path === '/404') {
        this.activeMenu = '';
      } else {
        this.activeMenu = this.$route.path;
      }
    },
  },

  methods: {
    onMenuSelect(key) {
      const nameMap = {
        '/call-plan': '电访计划',
        '/today-performance': '今日业绩',
        '/fieldServRecordQuery': '现场服务记录',
        '/latest-product': '最新产品',
      };
      this.addNav({
        path: key,
        name: nameMap[key],
        query: {
          today: 'yes',
        },
      });
    },
    handleSelect(href, name) {
      this.toPath(name, href);
    },

    handleSignOutClick() {
      const { userId } = this.sessData;
      const params = {
        data: {
          userId,
        },
      };
      this.$_yh_confirm('是否要退出当前登录?').then(() => {
        this.fullscreenLoading = !this.fullscreenLoading;
        this.logout(params);
      });
    },
    logout(params) {
      return this.$_post(this.$API.logout, params).then(() => {
        this.$store.commit('resetPageTab');
        this.$router.push({
          path: '/login',
        });
        try {
          // 前端使用的状态
          $.busitrans.sendKeyValue('isLogin', '0');
          // 给C#是否登录的状态
          $.busitrans.sendKeyValue('islogin', '0');
          $.busitrans.sendKeyValue('managerno', '');
        } catch (e) {
          this.$_throw(e);
        }
      });
    },
    toPath(pathName, pathUrl) {
      this.addNav({
        name: pathName,
        path: pathUrl,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/style/vars";

// 新样式
.app-container {
  height: 100vh;
}
.app-header {
  box-sizing: border-box;
  height: 60px;
  padding-left: 216px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("../assets/images/app_logo.png");
  background-repeat: no-repeat;
  background-position: 20px center;
}
.app-aside {
  background-color: #28313b;

  .el-menu-item {
    width: 195px;
    background-color: #28313b;
    color: #c0c4cc;

    &.is-active {
      color: #fff;
      background-color: #409eff;
    }
  }
}

.app-main {
  background-color: rgb(236, 239, 243);
  display: flex;
  flex-direction: column;

  .box {
    flex: 1;
    background-color: #fff;
    padding: 20px;
    border: 1px solid #d8dce6;
  }
}

.user-name {
  line-height: 28px;
  display: inline-block;
  vertical-align: top;
  margin-left: 1em;
  font-size: 14px;
  color: #606266;
}
.user-logo {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: tomato;
  background-image: url("../assets/images/avatar.png");
  background-size: cover;
}
.name-ellipsis {
  width: 70px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss">
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.user-detail [class*="el-icon-"],
.user-detail [class^="el-icon-"] {
  font-size: 28px;
  color: #c0c4cc;
  margin: 0 20px;
}
.el-table__body,
.el-table__footer,
.el-table__header {
  width: 100% !important;
}
</style>
